<template>
	<div>
		<v-card
			v-if="filepath"
			id="player-controls"
			@mousedown="mouseDown"
			class="elevation-10">

			<v-card-title class="pa-0 pl-2">
				<v-icon large color="color">drag_indicator</v-icon>
				<span class="px-2">{{ filepath }}</span>
				<v-btn large flat icon color="color" @click="close()" class="ma-O">
					<v-icon large>close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="pa-0">
				<v-btn
					block flat
					color="color"
					class="tc-btn display-3"
					@click="copyTc(timecode)">
					{{ timecode }}
					<span class="caption ml-1 pa-1 primary darken-1">Alt + T</span>
				</v-btn>
			</v-card-text>

			<v-card-actions class="pa-0">
				<v-spacer></v-spacer>
				<v-btn
					v-if="!player"
					flat icon large color="color"
					:loading="loading"
					@click="start()">
					<v-icon large>play_arrow</v-icon>
				</v-btn>
				<v-btn
					v-if="player"
					flat icon large color="color"
					:loading="loading"
					@click="play()">
					<v-icon large>play_arrow</v-icon>
				</v-btn>
				<v-btn
					v-if="player"
					flat icon large color="color"
					@click="pause()">
					<v-icon large>pause</v-icon>
				</v-btn>
				<v-btn
					v-if="player"
					flat icon large color="color"
					@click="stop()">
					<v-icon large>stop</v-icon>
				</v-btn>
				<v-btn
					v-if="player"
					flat icon large color="color"
					@click="capture()">
					<v-icon large>add_photo_alternate</v-icon>
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>

			<v-card-actions
				v-if="captures.length"
				class="pa-0"
				style="max-height: 350px; overflow: auto">
				<v-container grid-list-sm fluid class="pa-1">
					<v-layout row wrap>
						<v-flex v-for="(capture, i) in captures" :key="'capture_' + i" xs4>
							<v-card flat tile>
								<v-img
									:src="capture.image"
									:title="capture.timecode"
									height="100px">
								</v-img>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-actions>
			<v-card-actions v-if="captures.length">
				<v-spacer></v-spacer>
				<v-btn
					flat small
					color="color"
					class="ma-0 text-none"
					@click="downloadCaptures()">
					<v-icon>download</v-icon>
					Télécharger les captures
				</v-btn>
			</v-card-actions>

		</v-card>
	</div>
</template>

<script>
import throttle from 'lodash/throttle'
import download from 'downloadjs'
export default {
	props: [ 'filepath' ],
	data () {
		return {
			player: null,
			index: 0,
			timecode: '00:00:00:00',
			loading: false,
			captures: []
		}
	},
	watch: {
		filepath (val) {
			if (val) this.start()
		}
	},
	methods: {
		mouseDown (evt) {
			evt.preventDefault()
			let pos1 = 0
			let pos2 = 0
			let pos3 = evt.clientX
			let pos4 = evt.clientY
			document.onmousemove = throttle(function (e) {
				pos1 = pos3 - e.clientX
				pos2 = pos4 - e.clientY
				pos3 = e.clientX
				pos4 = e.clientY
				let el = document.getElementById('player-controls')
				el.style.top = (el.offsetTop - pos2) + 'px'
				el.style.left = (el.offsetLeft - pos1) + 'px'
			}, 0)
			document.onmouseup = () => {
				document.onmouseup = null
				document.onmousemove = null
			}
		},
		copyTc (tc) {
			this.$grv_clipboard.copyToClipboard(tc)
			this.$EventDialer(
				'success',
				false,
				`Copié dans le presse-papier : ${tc}`,
				null,
				1000
			)
		},
		chooseTc (tcs) {
			try {
				return Object.values(tcs).map(tc => {
					return { val: parseInt(tc.replace(/\W/, '')), tc: tc }
				}).sort((a, b) => {
					if (a.val < b.val) return 1
					if (a.val > b.val) return -1
					return 0
				})[0].tc
			} catch (error) {
				return Object.values(tcs)[0]
			}
		},
		downloadCaptures () {
			let fileName = this.filepath.substring(
				this.filepath.lastIndexOf('/') + 1,
				this.filepath.lastIndexOf('.')
			)
			for (const capture of this.captures) {
				let tcSuffix = `TC_${capture.timecode.replace(/:/g, '-')}`
				download(capture.image, `${fileName}_${tcSuffix}.jpg`)
			}
		},
		start () {
			let uri = `switch://server?port=6789&file=${this.filepath}`
			window.location.href = encodeURI(uri)
			this.loading = true
			setTimeout(() => {
				this.connect()
			}, 1000)
		},
		connect () {
			this.player = new WebSocket('ws://localhost:6789/')
			this.player.onopen = (event) => {
				this.play()
			}
			this.player.onerror = (error) => {
				console.log('player.onerror', error)
				this.connect()
			}
			this.player.onclose = (evt) => {
				console.log('player.onclose', evt)
			}
			this.player.onmessage = (event) => {
				this.loading = false
				if (event.data instanceof Blob) {
					return
				}
				const event_data = JSON.parse(event.data)
				if (event_data.kind === 'video') {
					if (event_data.index) {
						this.index = event_data.index
					}
					if (event_data.hasOwnProperty('timecodes')) {
						this.timecode = this.chooseTc(event_data.timecodes)
					}
				} else if (event_data.kind === 'image') {
					this.captures.push({
						image: `data:image/jpeg;base64,${event_data.image}`,
						timecode: this.chooseTc(event_data.timecodes)
					})
				}
			}
		},
		play () {
			this.player.send('play')
		},
		pause () {
			this.player.send('pause')
		},
		stop () {
			this.player.send('stop server')
			this.player = null
		},
		capture () {
			this.player.send('image at index ' + this.index.toString())
		},
		close () {
			this.player = null
			this.index = 0
			this.timecode = '00:00:00:00'
			this.loading = false
			this.captures = []
			this.$emit('close')
		},
		handleKeyDown (keyDownEvent) {
			if (keyDownEvent.altKey && keyDownEvent.key === 't') {
				this.copyTc(this.timecode)
			}
		}
	},
	mounted () {
		document.addEventListener('keydown', this.handleKeyDown)
	},
	beforeDestroy () {
		document.removeEventListener('keydown', this.handleKeyDown)
	}
}
</script>

<style lang="stylus" scoped>
#player-controls
	position: absolute
	cursor move
	z-index: 9
	top: 0
	left: 0
	background-color: var(--v-primary-base)
	color: var(--v-color-base)
	outline: 2px solid var(--v-primary-base)
	.tc-btn
		height: fit-content
</style>



// WEBPACK FOOTER //
// src/components/switch_player.vue